import React from 'react';
import { Alert } from 'antd';
import styled from 'styled-components';

const ErrorWrapper = styled.div`
  margin: 1rem auto;
  width: 70%;
`;

const Error = ({ message }) => {
  return (
    <ErrorWrapper>
      <Alert message="Error" description={message} type="error" showIcon />
    </ErrorWrapper>
  );
};

export default Error;
